import cuid from "cuid";
import { useMobileView } from 'hook/mobileView/useMobileView';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTicketsList } from "services/api/bulkClass";
import BulkRightSide from "./BulkRightSide";
import { LeftSide } from './LeftSide';
import { Body } from './Theme';

const BulkClassInfo = () => {
    const { isMobile } = useMobileView()
    const { bulkClassDetails } = useSelector((state) => state?.bulkClass)
    const dispatch = useDispatch()
    useEffect(() => {
        const ticketId = cuid();
        dispatch(setTicketsList([{
            id: ticketId,
            name: "Enrollment",
        }]));
        localStorage.setItem("registrationForm", JSON.stringify([]))
        localStorage.setItem("ApplayCheckBox", JSON.stringify(false))
    }, [])

    return (
        <Body>
            {Object.keys(bulkClassDetails || {}).length !== 0 && (
                <>
                    {!isMobile && <LeftSide
                        background={bulkClassDetails?.background}
                        description={bulkClassDetails?.description}
                    />}
                    <BulkRightSide />
                </>
            )}
        </Body>
    );
};

export default BulkClassInfo;